import React from 'react';
import {Link} from 'react-router-dom';

import classNames from 'classnames';
import {Avatar} from 'src/components/avatar/avatar';
import {Separator} from 'src/components/separator';
import {UserName} from 'src/components/user-name/user-name';
import {MAPPED_CHANGE_REQUEST_STATUS, OPENED_CHANGE_REQUEST_STATUSES} from 'src/modules/constants';
import {createEventReviewRoutePath} from 'src/modules/event-review/event-review-route-planner';
import {getUsersInfo} from 'src/modules/users-info/services';
import {ChangeRequest} from 'src/openapi/models/ChangeRequest';
import {useAppSelector} from 'src/store';

import {Group, Item} from '@pb/kit-component-group';
import {formatDate} from '@pb/kit-formatters';

import {changeLogClickable, changeLogHighlight, changeLogTextLink} from './change-log.module.styl';

type Props = {
    changeRequest: ChangeRequest,
};

export const ChangeLogItem = ({changeRequest}: Props) => {
    const userEmail = changeRequest.authorEmail;
    const user = useAppSelector(getUsersInfo)?.[userEmail];

    const classes = classNames({
        [changeLogClickable]: true,
        [changeLogHighlight]: OPENED_CHANGE_REQUEST_STATUSES.includes(changeRequest.status),
    });

    return (
        <Link
            to={createEventReviewRoutePath({changeRequestId: changeRequest.id ?? 0})}
            className={changeLogTextLink}>
            <Group direction="v" gap="none" className={classes}>
                <Item className="pdy-s">
                    <Group>
                        <Item style={{width: '9rem'}} className="pl-s">
                            {formatDate(changeRequest.updateDate)}
                        </Item>
                        <Item style={{width: 'calc(80% - 15rem)'}}>
                            <Group alignItems="center">
                                <Avatar user={user}/>
                                <UserName email={userEmail}/>
                            </Group>
                        </Item>
                        <Item style={{width: '15rem'}}>
                            {MAPPED_CHANGE_REQUEST_STATUS[changeRequest.status]}
                        </Item>
                    </Group>
                </Item>
                <Separator/>
            </Group>
        </Link>
    );
};
